module.exports = function () {
  return [
    {
      name: 'common',
      path: 'client/src/modules/common',
      compilePath: 'client/public/public/static/i18n/common',
    },
    {
      name: 'core',
      path: 'client/src/modules/core',
      compilePath: 'client/public/public/static/i18n/core',
    },
    {
      name: 'home',
      path: 'client/src/modules/home',
      compilePath: 'client/public/public/static/i18n/home',
    },
    {
      name: 'console',
      path: 'client/src/modules/console',
      compilePath: 'client/public/public/static/i18n/console',
    },
    {
      name: 'admin',
      path: 'packages/admin-ui/src',
      compilePath: 'client/public/public/static/i18n/admin',
    },
    {
      name: 'builder',
      path: 'client/src/modules/builder',
      compilePath: 'client/public/public/static/i18n/builder',
    },
    {
      name: 'tutorials',
      path: 'client/src/modules/tutorials',
      compilePath: 'client/public/public/static/i18n/tutorials',
    },
    {
      name: 'documentation',
      path: 'client/src/modules/documentation',
      compilePath: 'client/public/public/static/i18n/documentation',
    },
  ];
};
